var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner bill-edit-charge-dialog",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.title,
        "close-on-click-modal": false,
        width: "1000px",
        "append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "app-main-inner-row" },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "left", "label-width": "90px" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.BusinessNo") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { disabled: !!_vm.form.uuid },
                              on: { change: _vm.onJobChange },
                              model: {
                                value: _vm.form.jobUuid,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "jobUuid", $$v)
                                },
                                expression: "form.jobUuid"
                              }
                            },
                            _vm._l(_vm.simpleJobs, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.jobNo, value: item.uuid }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ChargeItem") } },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              filterable: "",
                              "method-params": _vm.chargeItemFilter,
                              "select-type":
                                _vm.selectTypeNames.basic_data_ChargeItem,
                              "default-value":
                                Number(_vm.form.chargeItemId) || "",
                              "options-width": "250px",
                              "tag-value": "itemId",
                              "tag-name": "zhName"
                            },
                            on: {
                              parentCallBack: function(p) {
                                return _vm.onCellChange("chargeItemId", p.value)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Currency") } },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              filterable: "",
                              clearable: false,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Currency,
                              "method-params": _vm.splitBill
                                ? { code: _vm.charge.currency }
                                : {},
                              "default-value": _vm.form.currency || "",
                              "options-width": "100px"
                            },
                            on: {
                              parentCallBack: function(p) {
                                return _vm.onCellChange("currency", p.value)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.UnitRate") } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              max: 999999999,
                              min: -999999999,
                              precision: 2,
                              controls: false
                            },
                            on: {
                              change: function($event) {
                                return _vm.onCellChange("unitRate")
                              }
                            },
                            model: {
                              value: _vm.form.unitRate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "unitRate", $$v)
                              },
                              expression: "form.unitRate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.ExcludingTaxAmount")
                          }
                        },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              max: 999999999,
                              min: -999999999,
                              precision: 2,
                              controls: false
                            },
                            on: {
                              change: function($event) {
                                return _vm.onCellChange("excludingTaxAmount")
                              }
                            },
                            model: {
                              value: _vm.form.excludingTaxAmount,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "excludingTaxAmount", $$v)
                              },
                              expression: "form.excludingTaxAmount"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.TaxRate") + "%" } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              max: 999999999,
                              min: -999999999,
                              precision: 2,
                              controls: false
                            },
                            on: {
                              change: function($event) {
                                return _vm.onCellChange("taxRate")
                              }
                            },
                            model: {
                              value: _vm.form.taxRate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "taxRate", $$v)
                              },
                              expression: "form.taxRate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Quantity2") } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              max: 999999999,
                              min: -999999999,
                              precision: 2,
                              controls: false
                            },
                            on: {
                              change: function($event) {
                                return _vm.onCellChange("quantity")
                              }
                            },
                            model: {
                              value: _vm.form.quantity,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "quantity", $$v)
                              },
                              expression: "form.quantity"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.IncludingTaxAmount")
                          }
                        },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              max: 999999999,
                              min: -999999999,
                              precision: 2,
                              controls: false
                            },
                            on: {
                              change: function($event) {
                                return _vm.onCellChange("amount")
                              }
                            },
                            model: {
                              value: _vm.form.amount,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "amount", $$v)
                              },
                              expression: "form.amount"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.BillAmount") } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              max: 999999999,
                              min: -999999999,
                              precision: 2,
                              controls: false,
                              disabled: true
                            },
                            model: {
                              value: _vm.form.taxAmount,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "taxAmount", $$v)
                              },
                              expression: "form.taxAmount"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Unit") } },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames.local_cache_ChargeMeasure,
                              filterable: "",
                              clearable: false,
                              "options-width": "100px",
                              "method-params": { seaFreight: true },
                              "default-value": _vm.form.measure || ""
                            },
                            on: {
                              parentCallBack: function(p) {
                                return _vm.onCellChange("measure", p.value)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "FinanceManage.charge_unitPriceIncludeTax"
                            )
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              filterable: "",
                              clearable: false,
                              fields: ["value"],
                              "default-value": _vm.form.unitPriceIncludeTax,
                              cache: false,
                              "tag-value": "code",
                              "tag-name": "value",
                              "options-width": "130px",
                              "static-options": [
                                { code: true, value: _vm.$t("SeaExport.Yes") },
                                { code: false, value: _vm.$t("SeaExport.No") }
                              ],
                              "filter-tag-names": ["value"]
                            },
                            on: {
                              parentCallBack: function(p) {
                                return _vm.onCellChange(
                                  "unitPriceIncludeTax",
                                  p.value
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.form.oversea
                    ? _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_PaymentType")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: !!_vm.form.uuid },
                                  model: {
                                    value: _vm.form.receivable,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "receivable", $$v)
                                    },
                                    expression: "form.receivable"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "DEBIT", value: true }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "CREDIT", value: false }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Remarks") } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", rows: 5 },
                            model: {
                              value: _vm.form.remarks,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "remarks", $$v)
                              },
                              expression: "form.remarks"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.save }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "mini" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }